<template>
  <validation-observer ref="observer" tag="fieldset">
    <b-card-body>
      <b-row>
        <b-col>
          <distribution-form-group
          id="vppCalculateAutomatically"
          vid="vppCalculateAutomatically"
          ref="vppCalculateAutomatically"
          :description="$t('choose_vpp_method_help_text') | capitalize"
          :label="$t('choose_vpp_method')"
          rules="required"
          >
          <b-form-radio-group required v-model="distribution.vpp.calculateAutomatically">
            <b-form-radio :value="false">{{ $t("manual") | capitalize }}</b-form-radio>
            <b-form-radio :value="true">{{ $t("automatic") | capitalize }}</b-form-radio>
          </b-form-radio-group>
        </distribution-form-group>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="distribution.vpp.calculateAutomatically === false && (distribution.college === distributionCollegeTypes.MAKER || distribution.college === distributionCollegeTypes.MAKER_AND_PERFORMER)">
      <b-col>
        <distribution-form-group
        id="vppMaker"
        vid="vppMaker"
        ref="vppMaker"
        :description="$t('vpp_help_text') | capitalize"
        :label="$t('maker_vpp')"
        label-cols="2"
        rules="double|positive|max_decimals_8"
        v-slot="{ state }"
        >
        <b-form-input v-model="distribution.vpp.maker" :state="state"/>
      </distribution-form-group>
    </b-col>
  </b-row>
  <b-row class="mt-2" v-if="distribution.vpp.calculateAutomatically === false && (distribution.college === distributionCollegeTypes.PERFORMER || distribution.college === distributionCollegeTypes.MAKER_AND_PERFORMER)">
    <b-col>
      <distribution-form-group
      id="vppPerformer"
      vid="vppPerformer"
      ref="vppPerformer"
      :description="$t('vpp_help_text') | capitalize"
      :label="$t('performer_vpp')"
      label-cols="2"
      rules="double|positive|max_decimals_8"
      v-slot="{ state }"
      >
      <b-form-input v-model="distribution.vpp.performer" :state="state"/>
    </distribution-form-group>
    </b-col>
  </b-row>
  <b-row class="mt-2">
    <b-col>
      <distribution-form-group
      id="vppStatus"
      vid="vppStatus"
      ref="vppStatus"
      :description="$t('vpp_type_help_text') | capitalize"
      :label="$t('vpp_type')"
      rules="required"
      label-cols="2"
      v-slot="{ state }"
      >
      <b-form-select required v-model="distribution.vpp.status" :options="vppTypeOptions" :state="state"/>
    </distribution-form-group>
  </b-col>
  </b-row>
  <b-row class="mt-1">
    <b-col>
      <distribution-form-group
      id="playcountsIneligiblePercentage"
      v-if="distribution.vpp.calculateAutomatically"
      vid="playcountsIneligiblePercentage"
      ref="playcountsIneligiblePercentage"
      :description="$t('playcounts_ineligible_help_text') | capitalize"
      :label="$t('playcounts_ineligible_percentage_short')"
      rules="required|double|min_value:0|max_value:100"
      label-cols="2"
      v-slot="{ state }"
      >
      <b-form-input required v-model="distribution.playcountsIneligiblePercentage" :state="state"></b-form-input>
    </distribution-form-group>
  </b-col>
  </b-row>
  <b-row class="mt-1">
    <b-col>
      <distribution-form-group
      id="playcountsUnmatchedPercentage"
      v-if="distribution.vpp.calculateAutomatically"
      vid="playcountsUnmatchedPercentage"
      ref="playcountsUnmatchedPercentage"
      :description="$t('playcounts_unmatched_help_text') | capitalize"
      :label="$t('playcounts_unmatched_percentage_short')"
      rules="required|double|min_value:0|max_value:100"
      label-cols="2"
      v-slot="{ state }"
      >
      <b-form-input required v-model="distribution.playcountsUnmatchedPercentage" :state="state"></b-form-input>
    </distribution-form-group>
  </b-col>
  </b-row>
  </b-card-body>
  </validation-observer>
</template>

<script>
import { distributionCollegeTypes, distributionVppTypes } from "@/constants"
import DistributionFormGroup from "@/components/DistributionFormGroup"
import { ValidationObserver } from "vee-validate"
import { capitalize } from "lodash"
import { distributionSectionMixin } from "@/utils/mixins"

export default {
  name: "VPPSection",
  components: { DistributionFormGroup, ValidationObserver },
  mixins: [ distributionSectionMixin ],
  props: {
    distribution: Object
  },
  data () {
    return {
      distributionCollegeTypes,
      vppTypeOptions: [
        {
          text: capitalize(this.$t("official")),
          value: distributionVppTypes.OFFICIAL,
        },
        {
          text: capitalize(this.$t("placeholder")),
          value: distributionVppTypes.PLACEHOLDER,
        },
      ]
    }
  }
}
</script>
